export const couponsForDealItems = [
];

export const couponsByUrl = [
  'SXSW15',
];
